var map = {
	"./scenario-0-assets/root111.png": "484c",
	"./scenario-1-assets/root111.png": "5d0b",
	"./scenario-2-assets/root111.png": "b630",
	"./scenario-3-assets/root111.png": "1218"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "d738";
module.exports = webpackAsyncContext;